var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1681.33 517.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#151616;}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 129.07,
    y1: -26.3,
    x2: 412.24,
    y2: 206.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 512.58,
    y1: 257.29,
    x2: 301.14,
    y2: 258.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 542.19,
    y1: 264.36,
    x2: 351.34,
    y2: 249.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 517.34,
    y1: 235.21,
    x2: 149.97,
    y2: 479.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1681.33,
    height: 517.66,
    rx: 59.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M661.58,172q0,11.61-6.89,18.5-7.82,8.2-20.36,8.2a28.55,28.55,0,0,1-28.8-29,28.57,28.57,0,0,1,28.8-29,28.57,28.57,0,0,1,11.38,2.33,22.86,22.86,0,0,1,8.67,6.19l-4.87,4.88q-5.5-6.58-15.18-6.58a21.09,21.09,0,0,0-15.14,6.15q-6.39,6.16-6.38,16t6.38,16a22.08,22.08,0,0,0,30.62,0q4-4,4.65-11.23H634.33v-6.66h26.86A23.68,23.68,0,0,1,661.58,172Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M704.16,148.8H678.92v17.57h22.76V173H678.92V190.6h25.24v6.81H671.8V142h32.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M734.19,197.41h-7.12V148.8H711.58V142h38.1v6.82H734.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M777.24,197.41V142h7.12v55.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M816,197.41h-7.13V148.8H793.34V142h38.09v6.82H816Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M903.54,190.25a28.79,28.79,0,0,1-40.65,0,30,30,0,0,1,0-41.1,28.68,28.68,0,0,1,40.61,0,29.87,29.87,0,0,1,0,41.07Zm-35.39-4.64a21.32,21.32,0,0,0,30.12,0q6.15-6.24,6.16-15.91t-6.16-15.91a21.32,21.32,0,0,0-30.12,0Q862,160,862,169.7T868.15,185.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M921.7,197.41V142h8.67l26.94,43.12h.3l-.3-10.68V142h7.12v55.43H957L928.82,152.2h-.31l.31,10.69v34.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M853,278.26a39.62,39.62,0,0,0-28,11.27,40,40,0,0,0,1.39,57.31,40.5,40.5,0,0,0,52,1.1,38.79,38.79,0,0,0,14.08-30.39A38.71,38.71,0,0,0,853,278.26Zm0,63.11c-11.9,0-22.18-9.82-22.18-23.82s10.28-23.81,22.18-23.81,22.18,9.68,22.18,23.81S864.88,341.37,853,341.37Zm-86-63.11a40.23,40.23,0,0,0-22,6.43,39.83,39.83,0,0,0-5.84,61A40.48,40.48,0,0,0,790.92,349a38.72,38.72,0,0,0,15.45-31.46A39.77,39.77,0,0,0,801,297.34,39.06,39.06,0,0,0,766.93,278.26Zm0,63.11c-11.91,0-22.17-9.82-22.17-23.82s10.26-23.81,22.17-23.81,22.18,9.68,22.18,23.81S778.84,341.37,766.93,341.37ZM664.58,290.32V307h39.89c-1.19,9.37-4.32,16.22-9.08,21-5.8,5.81-14.88,12.21-30.81,12.21-24.56,0-43.75-19.8-43.75-44.35s19.19-44.36,43.75-44.36a42.52,42.52,0,0,1,30.07,11.91l11.75-11.76c-10-9.52-23.21-16.82-41.82-16.82a61.79,61.79,0,0,0-31.52,8.66c-18.06,10.67-30.39,30.16-30.39,52.37,0,22.91,13.12,42.92,32.11,53.35a61.87,61.87,0,0,0,29.8,7.67c18.16,0,31.85-6,42.57-17.12,11-11,14.44-26.49,14.44-39a54,54,0,0,0-.9-10.42H664.58Zm418.57,12.95c-3.27-8.78-13.24-25-33.63-25a36.33,36.33,0,0,0-23.16,8.17c-8.44,6.92-13.9,17.81-13.9,31.12,0,22,16.67,39.3,39,39.3a39.07,39.07,0,0,0,32.74-17.42l-13.39-8.93c-4.46,6.55-10.57,10.87-19.35,10.87s-15-4-19-11.91l52.54-21.73Zm-53.58,13.09c-.44-15.18,11.76-22.92,20.54-22.92,6.85,0,12.65,3.43,14.59,8.34l-18.35,7.62Zm-42.71,38.11h17.26V239H986.86ZM958.58,287H958c-3.86-4.61-11.31-8.78-20.68-8.78a36.74,36.74,0,0,0-24.59,9.86,39.76,39.76,0,0,0,4,62.15,36.28,36.28,0,0,0,20.55,6.58c9.37,0,16.82-4.17,20.68-8.93h.6v5.65c0,15-8,23.07-21,23.07-10.56,0-17.11-7.59-19.79-14l-15,6.25c4.31,10.42,15.77,23.22,34.82,23.22,20.25,0,37.36-11.91,37.36-40.93V280.64H958.58Zm-19.79,54.33c-11.91,0-21.88-10-21.88-23.67s10-24,21.88-24c11.75,0,21,10.12,21,24S950.54,341.37,938.79,341.37ZM1164,239h-41.3v115.5H1140V310.71H1164a39.45,39.45,0,0,0,29.13-12.65,35.16,35.16,0,0,0,.23-46.18A39.41,39.41,0,0,0,1164,239Zm.45,55.67H1140V255.05h24.52a19.8,19.8,0,1,1,0,39.59ZM1271,278.05c-12.48,0-25.4,5.5-30.75,17.68l15.3,6.39c3.27-6.39,9.36-8.47,15.75-8.47,8.91,0,18,5.35,18.13,14.86v1.19a38.18,38.18,0,0,0-18-4.46,41.82,41.82,0,0,0-20.09,4.94c-7.74,4.31-13.19,11.41-13.19,21.06a23.76,23.76,0,0,0,10,19.58,31.6,31.6,0,0,0,18.64,5.83c11.59,0,18-5.2,22-11.29h.6v8.91h16.64V310c0-12.18-5.4-21.15-13.91-26.44C1286.33,279.94,1279,278.05,1271,278.05Zm-2.08,63.3c-5.64,0-13.52-2.83-13.52-9.81,0-8.91,9.81-12.33,18.28-12.33,7.58,0,11.14,1.63,15.75,3.86A20.9,20.9,0,0,1,1268.92,341.35Zm97.77-60.77-8.18,20.73-11.58,29.34h-.6l-20.5-50.07h-18.57l14.83,33.75L1338,350.56l-17.53,38.93h18l33.62-77.27,13.78-31.64Zm-155.27,73.89h17.24V239h-17.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M472,218.53,334.69,138a14.94,14.94,0,0,0-19.61,4L431.35,259Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.18,366.37a14.79,14.79,0,0,0,2.65,8.53L431.35,259,315.08,142a14.72,14.72,0,0,0-2.9,8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M471.28,299.12l47.06-27.61a15,15,0,0,0,0-25.78L472,218.53,431.35,259Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M314.83,374.9a15,15,0,0,0,19.86,4.36l136.59-80.14L431.35,259Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.dbb0bb3a2d2c780aa4f69b492d4c45ce.svg";
export { ForwardRef as ReactComponent };